import React, { useState } from 'react';
import Card from '../shared/Card';
import Button from '../shared/Button';
import Textarea from '../shared/Textarea';
import './MarketForm.css';

const MarketForm = ({ onSubmit, isSubmitting }) => {
  const [question, setQuestion] = useState('');
  const [error, setError] = useState(null);

  const handleSubmit = () => {
    if (question.trim().length < 10) {
      setError('Question must be at least 10 characters');
      return;
    }
    setError(null);
    onSubmit(question.trim());
  };

  return (
    <div className="market-form">
      <Card title="Create Factor Graph">
        <p className="market-form__description">
          Enter a prediction market question to decompose into its fundamental driving factors.
        </p>
        <Textarea
          label="Market Question"
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          placeholder="e.g., Will the price of eggs be above $2.50 in February 2026?"
          required
          maxLength={500}
          showCounter
          rows={3}
          error={error}
        />
        <div className="market-form__examples">
          <span className="market-form__examples-label">Examples:</span>
          <button
            type="button"
            className="market-form__example"
            onClick={() => setQuestion('Will the price of eggs be above $2.50 in February 2026?')}
          >
            Egg prices
          </button>
          <button
            type="button"
            className="market-form__example"
            onClick={() => setQuestion('Will NVIDIA stock price exceed $200 by end of 2025?')}
          >
            NVIDIA stock
          </button>
          <button
            type="button"
            className="market-form__example"
            onClick={() => setQuestion('Will there be a US recession in 2026?')}
          >
            US recession
          </button>
        </div>
        <Button
          onClick={handleSubmit}
          disabled={isSubmitting || question.trim().length < 10}
          fullWidth
        >
          {isSubmitting ? 'Creating...' : 'Decompose Market'}
        </Button>
      </Card>
    </div>
  );
};

export default MarketForm;
